import React from 'react';
import { useAchievements } from '../hooks/useAchievements';
import { useGamification } from '../hooks/GamificationContext';

export function ProfileAchievements() {
  const achievements = useAchievements();
  const { loading = false, hasLoaded = false } = useGamification();

  if (loading && !hasLoaded) {
    return null;
  }

  if (!achievements.length) {
    return null;
  }

  const rareCount = achievements.filter((item) => ['rare', 'epic', 'legendary'].includes(item.rarity)).length;

  return (
    <section className="pfp-profile-achievements-panel">
      <div className="pfp-profile-achievements-head">
        <div>
          <span className="pfp-profile-achievements-kicker">Logbuch der Erfolge</span>
          <h3>Deine Auszeichnungen</h3>
          <p>Freigeschaltete Meilensteine aus Pfand, Expeditionen, Schritten und Loot.</p>
        </div>
        <div className="pfp-profile-achievements-count">
          <strong>{achievements.length}</strong>
          <span>{rareCount ? `${rareCount} selten` : 'freigeschaltet'}</span>
        </div>
      </div>

      <div className="pfp-profile-achievements-grid">
        {achievements.map((achievement) => (
          <div
            key={achievement.key}
            className={`pfp-profile-achievement-card rarity-${achievement.rarity || 'common'}`}
          >
            <div className="pfp-profile-achievement-visual">
              {achievement.badge_image_url ? (
                <img src={achievement.badge_image_url} alt="" loading="lazy" />
              ) : (
                <span>{achievement.badge_icon || '🏅'}</span>
              )}
            </div>
            <div className="pfp-profile-achievement-copy">
              <strong>{achievement.title}</strong>
              {achievement.description ? <p>{achievement.description}</p> : null}
              <small>{achievement.rarity || 'common'}</small>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
